/* eslint-disable @nx/enforce-module-boundaries */

import CalendarPage from 'v4/snippets/calendar';
import { Container } from '@mybridge/ui';
import { isMobile } from 'react-device-detect';
import Head from 'next/head';
import { useSelector } from 'react-redux';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
const Disk = () => {
  const { loggedIn } = useSelector((state) => state.user);
  const { globalNotifCount } = useSelector((state) => state.notifications);
  const { t } = useTranslator();
  return (
    <>
      <Head>
        <title>
          {/* {loggedIn && globalNotifCount ? `(${globalNotifCount})` : ''}{' '} */}
          myCalendar | myBridge.me
        </title>
      </Head>
      <Container w="1320px"  bg="white" maxW="100%" p={!isMobile ? ['5px 10px 0', 0] : ''} h="100%">
        <CalendarPage />
      </Container>

    </>
  );
};

export default Disk;
